import axios from '@/utils/axios';

// 会员详细
export function memberDetail() {
    return axios({
        url: '/account',
        method: 'get',
        params: { },
    });
}

// 会员资料编辑
export function memberEdit(username, realname, mobile, captcha, email, qq, password, sex, birthday, province, city, area, address, acceptEmail, acceptSms) {
    return axios({
        url: '/account/update',
        method: 'post',
        params: { username, realname, mobile, captcha, email, qq, password, sex, birthday, province, city, area, address, acceptEmail, acceptSms },
    });
}

//阅读平台协议
export function ruleRead() {
    return axios({
        url: '/account/rule/read',
        method: 'post',
        params: { },
    });
}

//会员参与游戏状态
export function memberGameStatus() {
    return axios({
        url: '/account/status',
        method: 'get',
        params: {},
    });

}

//更新会员本月已参与游戏
export function updateMemberGameStatus() {
    return axios({
        url: '/account/update/game',
        method: 'get',
        params: { },
    });

}